export default __webpack_public_path__ + "568a77c1c211bc6daa94e4ad92099c39.png";